import React from 'react';
import PropTypes from 'prop-types';
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import EventTimeLine from '../EventTimeLine';

export default function MilestoneSlidingPane(props) {
  return (
    <SlidingPane
      isOpen={props.isOpen}
      onRequestClose={props.closeSlidingPane}
      width={'40%'}
      closeIcon={
        <i
          className="fa fa-times"
          aria-hidden="true"
          style={{ fontSize: 20 }}
        />
      }
    >
      {/* eslint-disable-next-line react/prop-types */}
      {props.children ? (
        props.children
      ) : (
        <EventTimeLine timelineData={props.milestoneData} />
      )}
    </SlidingPane>
  );
}

MilestoneSlidingPane.propTypes = {
  milestoneData: PropTypes.array,
  isOpen: PropTypes.bool,
  closeSlidingPane: PropTypes.func
};
